<template>
    <div
        class="section-body px-4 mb-4 w-full"
        :class="{
            'mb-12': section_type !== 'site_admin' && section_type !== 'association',
            'mb-4 mt-4': section_type == 'site_admin' || section_type == 'association',
        }"
    >
        <div
            class="flex w-full px-2 mb-2"
            :class="{
                'sm:w-1/2 md:w-1/2': section_type !== 'site_admin' && section_type !== 'association',
            }"
            data-cy="claim-third-name-field"
        >
            <ui-label class="w-2/5">
                {{ $t('claim.view.labels.third_party.name') }}
            </ui-label>
            <div class="subText w-3/5">
                {{ claimant.claimant_name }}
            </div>
        </div>
        <div
            class="flex w-full px-2 mb-2"
            :class="{
                'sm:w-1/2 md:w-1/2': section_type !== 'site_admin' && section_type !== 'association',
            }"
            data-cy="claim-third-driver-field"
            v-if="claimant.is_motor"
        >
            <ui-label class="w-2/5">
                {{ $t('claim.view.labels.third_party.driver') }}
            </ui-label>
            <div class="subText w-3/5">
                {{ claimant.driver_name }}
            </div>
        </div>
        <div
            class="flex w-full px-2 mb-2"
            :class="{
                'sm:w-1/2 md:w-1/2': section_type !== 'site_admin' && section_type !== 'association',
            }"
            data-cy="claim-third-risk-field"
        >
            <ui-label class="w-2/5">
                {{ $t('claim.view.labels.third_party.risk_detail') }}
            </ui-label>
            <div class="subText w-3/5">
                {{ claimant.risk_details }}
            </div>
        </div>
        <div
            class="flex w-full px-2 mb-2"
            :class="{
                'sm:w-1/2 md:w-1/2': section_type !== 'site_admin' && section_type !== 'association',
            }"
            data-cy="claim-third-dob-field"
            v-if="claimant.is_motor"
        >
            <ui-label class="w-2/5">
                {{ $t('claim.view.labels.third_party.driver_info') }}
            </ui-label>
            <div class="subText w-3/5" v-if="claimant.driver_dob != '0000-00-00'">
                {{ claimant.driver_dob }}
            </div>
        </div>
        <div
            class="flex w-full px-2 mb-2"
            :class="{
                'sm:w-1/2 md:w-1/2': section_type !== 'site_admin' && section_type !== 'association',
            }"
            data-cy="claim-third-vin-field"
            v-if="claimant.is_motor"
        >
            <ui-label class="w-2/5">
                {{ $t('claim.view.labels.third_party.engine_number') }}
            </ui-label>
            <div class="subText w-3/5">
                <span v-if="claimant.engine_number != ''">
                    {{ claimant.chassis_number }} : {{ claimant.engine_number }}
                </span>
                <span v-else>
                    {{ claimant.chassis_number }}
                </span>
            </div>
        </div>
        <div
            class="flex w-full px-2 mb-2"
            :class="{
                'sm:w-1/2 md:w-1/2': section_type !== 'site_admin' && section_type !== 'association',
            }"
            data-cy="claim-third-license-field"
            v-if="claimant.is_motor"
        >
            <ui-label class="w-2/5">
                {{ $t('claim.view.labels.third_party.license') }}
            </ui-label>
            <div class="subText w-3/5">
                {{ claimant.driver_drv_license_number }}
            </div>
        </div>
        <div
            class="flex w-full px-2 mb-2"
            :class="{
                'sm:w-1/2 md:w-1/2': section_type !== 'site_admin' && section_type !== 'association',
            }"
            data-cy="claim-third-cover-field"
            v-if="claimant.is_motor"
        >
            <ui-label class="w-2/5">
                {{ $t('claim.view.labels.third_party.cover_type') }}
            </ui-label>
            <div class="subText w-3/5">
                {{ claimant.cover_type }}
            </div>
        </div>
        <div
            class="flex w-full px-2 mb-2"
            :class="{
                'sm:w-1/2 md:w-1/2': section_type !== 'site_admin' && section_type !== 'association',
            }"
            data-cy="claim-third-lic-date-field"
            v-if="claimant.is_motor"
        >
            <ui-label class="w-2/5">
                {{ $t('claim.view.labels.third_party.license_date') }}
            </ui-label>
            <div class="subText w-3/5" v-if="claimant.driver_drv_license_issue_date != '0000-00-00'">
                {{ claimant.driver_drv_license_issue_date }}
            </div>
        </div>
        <div
            class="flex w-full px-2 mb-2"
            :class="{
                'sm:w-1/2 md:w-1/2': section_type !== 'site_admin' && section_type !== 'association',
            }"
            data-cy="claim-third-insurer-field"
        >
            <ui-label class="w-2/5">
                {{ $t('claim.view.labels.third_party.insurer') }}
            </ui-label>
            <div class="subText w-3/5">
                <span v-if="claimant.insurer_ref != ''">
                    {{ claimant.associated_insurer }} : {{ claimant.insurer_ref }}
                </span>
                <span v-else>
                    {{ claimant.associated_insurer }}
                </span>
            </div>
        </div>
        <div
            class="flex w-full px-2 mb-2"
            :class="{
                'sm:w-1/2 md:w-1/2': section_type !== 'site_admin' && section_type !== 'association',
            }"
            data-cy="claim-third-driver-trn-field"
            v-if="claimant.is_motor"
        >
            <ui-label class="w-2/5">
                {{ $t('claim.view.labels.third_party.driver_trn') }}
            </ui-label>
            <div class="subText w-3/5">
                {{ claimant.trn }}
            </div>
        </div>
        <div
            class="flex w-full px-2 mb-2"
            :class="{
                'sm:w-1/2 md:w-1/2': section_type !== 'site_admin' && section_type !== 'association',
            }"
            data-cy="claim-third-driver-trn-field"
            v-if="!claimant.is_motor"
        >
            <ui-label class="w-2/5">
                {{ $t('claim.view.labels.third_party.national_id') }}
            </ui-label>
            <div class="subText w-3/5">
                {{ claimant.trn }}
            </div>
        </div>
        <div
            class="flex w-full px-2 mb-2"
            :class="{
                'sm:w-1/2 md:w-1/2': section_type !== 'site_admin' && section_type !== 'association',
            }"
            data-cy="claim-third-lawyer-field"
        >
            <ui-label class="w-2/5">
                {{ $t('claim.view.labels.third_party.lawyer') }}
            </ui-label>
            <div class="subText w-3/5">
                {{ claimant.tp_lawyer }}
            </div>
        </div>
        <div
            class="flex w-full px-2 mb-2"
            :class="{
                'sm:w-1/2 md:w-1/2': section_type !== 'site_admin' && section_type !== 'association',
            }"
            data-cy="claim-third-medical-field"
        >
            <ui-label class="w-2/5">
                {{ $t('claim.view.labels.third_party.medical') }}
            </ui-label>
            <div class="subText w-3/5">
                {{ claimant.tp_medical_doctor }}
            </div>
        </div>
        <div
            class="flex w-full px-2 mb-2"
            :class="{
                'sm:w-1/2 md:w-1/2': section_type !== 'site_admin' && section_type !== 'association',
            }"
            data-cy="claim-third-file-source-field"
            v-if="section_type == 'site_admin' || section_type == 'association'"
        >
            <ui-label class="w-2/5">
                {{ $t('claim.view.labels.third_party.file_source') }}
            </ui-label>
            <div class="subText w-3/5">
                {{ claimant.file_source }}
            </div>
        </div>
        <div
            class="flex w-full px-2 mb-2"
            :class="{
                'sm:w-1/2 md:w-1/2': section_type !== 'site_admin' && section_type !== 'association',
            }"
            data-cy="claim-third-updated-at-field"
            v-if="section_type == 'site_admin' || section_type == 'association'"
        >
            <ui-label class="w-2/5">
                {{ $t('claim.view.labels.third_party.updated_at') }}
            </ui-label>
            <div class="subText w-3/5">
                {{ lastUpdatedAt }}
            </div>
        </div>
        <div
            class="drawer-footer"
            v-if="form_mode == 'drawer' && (section_type == 'site_admin' || section_type == 'association')"
        >
            <slot name="actions"></slot>

            <a-button data-cy="drawer-cancel-button" @click="onDrawerClose" class="btn-cancel">
                {{ $t('claim.view.buttons.cancel') }}
            </a-button>
        </div>
    </div>
</template>

<script>
import UiLabel from '@/components/ui/Label.vue';

export default {
    components: {
        UiLabel,
    },
    props: {
        claimant: {
            type: Object,
            default: {},
        },
        section_type: {
            type: String,
            default: 'default',
        },
        form_mode: {
            type: String,
            default: 'init',
        },
    },
    computed: {
        lastUpdatedAt() {
            return this.$dayjs(this.claimant.updated_at).format('YYYY-MM-DD @ h:mm:ss A');
        },
    },
    methods: {
        onDrawerClose() {
            this.$emit('onDrawerClose');
        },
    },
};
</script>
